import { createContext, useContext, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const lookup = (lang, key) => key.split(".").reduce((o, k) => (o == null ? o : o[k]), translations[lang]);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rc_lang") || "it");

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("rc_lang", l);
    document.documentElement.lang = l;
  };

  const t = (key) => lookup(lang, key) ?? lookup("it", key) ?? key;

  return <LanguageContext.Provider value={{ lang, changeLang, t }}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
